/**
 * en-GB messages added by Phase 3 task C4 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const c4EnGB = {};
//# sourceMappingURL=c4.js.map